// src/components/Footer.js
import React from "react";

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-8 mt-16">
      <div className="container mx-auto px-4 text-center">
        <p className="text-lg font-semibold">Karangou Studios</p>
        <p className="text-sm mt-2">
          ©️ {new Date().getFullYear()} Tous droits réservés. Contribuez à l'essor du cinéma africain.
        </p>
        <div className="mt-4 flex justify-center gap-6 text-gray-400">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">Facebook</a>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">Twitter</a>
          <a href="mailto:contact@karangoustudios.com" className="hover:text-white transition">Contact</a>
        </div>
      </div>
    </footer>
  );
}
